import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { EditorialXAxisPadding, processColorMode, Fonts, FontWeight, LineHeights, TextVariants } from "../../index";
export const Standfirst = ({ sentence, credits, mode = "dark" }) => {
    return (_jsxs(Flex, { sx: Object.assign(Object.assign({}, processColorMode(mode)), { py: [32, 56], px: EditorialXAxisPadding, justifyContent: "space-between", flexWrap: "wrap", alignItems: "center", width: "100%", flex: 1 }), children: [_jsx(Flex, { sx: {
                    flexWrap: "wrap",
                    variant: `text.${TextVariants.technicalParagraphLarge}`,
                    mb: [32, null, null, 0],
                    width: [
                        "100%",
                        null,
                        null,
                        `${(7 / 16) * 100}%`,
                        `${(6 / 16) * 100}%`,
                        `${(5 / 16) * 100}%`
                    ],
                    "& > * + .standfirst-credit": {
                        mt: [8, null, null, 8]
                    }
                }, children: credits === null || credits === void 0 ? void 0 : credits.map((item, idx) => {
                    return (_jsxs(Flex, { sx: { width: "100%", flexWrap: "wrap" }, className: "standfirst-credit", children: [_jsx("span", { sx: { mr: 8 }, children: item.label }), _jsx("span", { className: "color-mode-title", children: item.value })] }, idx));
                }) }), _jsx(Box, { className: "color-mode-title", sx: {
                    fontFamily: Fonts.text,
                    fontWeight: FontWeight.textRegular,
                    lineHeight: LineHeights.editorial,
                    fontSize: "scale1",
                    width: [
                        "100%",
                        null,
                        null,
                        `${(7 / 16) * 100}%`,
                        `${(6 / 16) * 100}%`,
                        `${(5 / 16) * 100}%`
                    ],
                    maxWidth: ["80vw", null, null, null, "30vw"]
                }, children: _jsx("p", { children: sentence }) })] }));
};
//# sourceMappingURL=StandFirst.js.map